import DeliveryService from "../DeliveryService"


const Enterprise = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/console/enterprises'
        if (r != undefined) {
            url = '/console/enterprises?' + r
        }
        return DeliveryService.get(url)
    },
    getOrders(id, r) {
        let url = '/console/enterprises'
        if (r != undefined) {
            url = '/console/enterprises/' + id + '/orders?' + r
        }
        return DeliveryService.get(url)
    },
    getSaleReport(ref, r) {
        let url = '/console/enterprises'
        if (r != undefined) {
            url = '/console/enterprises/' + ref + '/report_sale?' + r
        }
        return DeliveryService.get(url)
    },
}
export default Enterprise
